export default __webpack_public_path__ + "static/video1-b5ca0a63ee05c594a8aaa3d94d5a96ae.webp";